import { useCallback } from "react";
import { useAppDispatch } from '../app/hooks';
import { dialogActions } from "../components/dialog/slice/dialog-slice";

export const useErrorMessage = () => {
  const dispatch = useAppDispatch();
  const pushMessage = useCallback((
    title: string,
    message: string[],
    opt?: {
      onClickOk?: () => void,
      buttons?: {
        label: string,
        callback: () => void,
        options?: {
          waitActive?: number,
        },
      }[],
    }
  ) => {
    dispatch(dialogActions.pushMessage({
      title,
      message: message,
      buttons: [
        {
          label: 'OK',
          callback: () => {
            opt?.onClickOk?.();
            dispatch(dialogActions.pop());
          },
        },
        ...opt?.buttons ?? [],
      ],
    }));

  }, [dispatch]);

  return {
    pushMessage,
  }
}